enum ActivityReliabilityReason {
  DISTANCE = "checked in outside allowed distance",
  ENTITY = "changed checked-in association",
  GPS_ACCURACY = "inaccurate GPS accuracy",
  TIME = "manually changed the start time",
}

export default ActivityReliabilityReason;
